export enum CompanyLogoUploadActionType {
  UploadCompanyLogo = 'companyLogoUpload/UploadCompanyLogo',
  UploadCompanyLogoSuccess = 'companyLogoUpload/UploadCompanyLogoSuccess',
  UploadCompanyLogoFailure = 'companyLogoUpload/UploadCompanyLogoFailure',
  OpenCompanyLogoUploadDialog = 'companyLogoUpload/OpenCompanyLogoUploadDialog',
  CloseCompanyLogoUploadDialog = 'companyLogoUpload/CloseCompanyLogoUploadDialog',
}
